'use client';

import { createContext, useContext, type ReactNode } from 'react';

import type { Course, TableOfContent } from '@openclassrooms/sdk-web';

type ChapterContextValue = {
  canEditCourse: boolean;
  course: Course;
  chapterContent: string;
  tableOfContent: TableOfContent;
  flatToc: TableOfContent[];
  currentChapter?: {
    id: number | undefined;
    isCompleted: boolean;
    type: string;
    title: string;
    parentId: number | undefined;
  };
};

const ChapterContext = createContext<ChapterContextValue | undefined>(undefined);

type Props = {
  children: ReactNode;
  value: ChapterContextValue;
};

export const ChapterProvider = ({ children, value }: Props) => (
  <ChapterContext.Provider value={value}>{children}</ChapterContext.Provider>
);

export const useChapterContext = () => {
  const context = useContext(ChapterContext);
  if (!context) {
    throw new Error('useChapterContext must be used within a ChapterPovider');
  }
  return context;
};
